export default {
  name: 'generalinfo',
  data () {
    return {
      label: 'GENERAL INFO',
      componentValue: this.value
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    componentValue: function () {
      this.$emit('input', this.componentValue)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/generalinfo/script.js